/* generated by pull.js */
export default {
  "de": () => require("../addons-l10n-settings/de.json"),
  "es": () => require("../addons-l10n-settings/es.json"),
  "fi": () => require("../addons-l10n-settings/fi.json"),
  "fr": () => require("../addons-l10n-settings/fr.json"),
  "hu": () => require("../addons-l10n-settings/hu.json"),
  "it": () => require("../addons-l10n-settings/it.json"),
  "ja": () => require("../addons-l10n-settings/ja.json"),
  "ko": () => require("../addons-l10n-settings/ko.json"),
  "nl": () => require("../addons-l10n-settings/nl.json"),
  "pl": () => require("../addons-l10n-settings/pl.json"),
  "pt": () => require("../addons-l10n-settings/pt.json"),
  "ro": () => require("../addons-l10n-settings/ro.json"),
  "ru": () => require("../addons-l10n-settings/ru.json"),
  "sl": () => require("../addons-l10n-settings/sl.json"),
  "tr": () => require("../addons-l10n-settings/tr.json"),
  "zh-cn": () => require("../addons-l10n-settings/zh-cn.json"),
  "zh-tw": () => require("../addons-l10n-settings/zh-tw.json"),
};
